import {
  ADD_BOOTH,
  EDIT_BOOTH,
  CLOSE_BOOTH,
  SHOW_ADD_BOOTH_INFO,
  FETCH_LINK_RESOURCE,
  FETCH_INTERACTIVE_MAPS,
  SHOW_BOOTH_EDITOR,
  UPDATE_BOOTH_COLOR,
  DELETE_BOOTH_LINK,
  OPEN_IMAP,
  ADD_IMAP_NAME,
  OPEN_IMAP_MODAL,
  MAP_IMAGE_CHANGED,
  CHANGE_MAP_IMAGE,
  DEFAULT_IMAP_VALUE,
  UPDATE_IMAP_UPLOAD_PROGRESS,
  IMAP_IMAGE_UPLOAD_FAILED,
  IMAP_IMAGE_UPLOADED,
  IMAP_IMAGE_TO_UPLOAD,
  ADD_BOOTH_DATA,
  EDIT_BOOTH_DATA,
  INTERACTIVEMAPLOCATION_SESSION_LINK_DATA_WITH_EVENTID,
} from "IMapConstants";

export function AddEditBoothReducer(
  state = { toEditBooth: false, toAddNewBooth: false, cancelledBooth: {} },
  action
) {
  switch (action.type) {
    case EDIT_BOOTH:
      return action.payload;
    case ADD_BOOTH:
      return action.payload;
    case CLOSE_BOOTH:
      return {
        toEditBooth: false,
        toAddNewBooth: false,
        cancelledBooth: action.payload,
      };
    default:
      return state;
  }
}

export function ShowBoothEditorReducer(state = false, action) {
  switch (action.type) {
    case SHOW_BOOTH_EDITOR:
      return action.payload;
    default:
      return state;
  }
}

export function ShowAddBoothInfoReducer(state = false, action) {
  switch (action.type) {
    case SHOW_ADD_BOOTH_INFO:
      return action.payload;
    default:
      return state;
  }
}

export function AddBoothDataReducer(state = {}, action) {
  switch (action.type) {
    case ADD_BOOTH_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function EditBoothDataReducer(state = {}, action) {
  switch (action.type) {
    case EDIT_BOOTH_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function FetchLinkResourceReducer(state = {}, action) {
  switch (action.type) {
    case FETCH_LINK_RESOURCE:
      return {
        payload: action.payload.resource[0],
      };
    default:
      return state;
  }
}

export function FetchInteractiveMapsReducer(state = {}, action) {
  switch (action.type) {
    case FETCH_INTERACTIVE_MAPS:
      return action.payload.resource;
    default:
      return state;
  }
}

export function OpenIMapReducer(state = DEFAULT_IMAP_VALUE, action) {
  var payload = state;
  if (action.payload && action.payload.resource)
    payload = action.payload.resource[0];
  else payload = action.payload;

  switch (action.type) {
    case OPEN_IMAP:
      return payload;
    default:
      return state;
  }
}

export function UpdatedBoothReducer(state = {}, action) {
  switch (action.type) {
    case UPDATE_BOOTH_COLOR:
      return {
        payload: action.payload,
      };
    default:
      return state;
  }
}

export function DeleteBoothLinkReducer(state = {}, action) {
  switch (action.type) {
    case DELETE_BOOTH_LINK:
      return {
        payload: action.payload,
      };
    default:
      return state;
  }
}

export function AddMapNameReducer(state = {}, action) {
  switch (action.type) {
    case ADD_IMAP_NAME:
      return {
        payload: action.payload,
      };
    default:
      return state;
  }
}

export function OpeniMapModalReducer(state = false, action) {
  switch (action.type) {
    case OPEN_IMAP_MODAL:
      return {
        payload: action.payload,
      };
    default:
      return state;
  }
}

export function ChangeMapReducer(state = false, action) {
  switch (action.type) {
    case CHANGE_MAP_IMAGE:
      return action.payload;
    case MAP_IMAGE_CHANGED:
      return action.payload;
    default:
      return state;
  }
}

export function UploadImapProgressReducer(state = 0, action) {
  switch (action.type) {
    case UPDATE_IMAP_UPLOAD_PROGRESS:
      return action.payload;
    default:
      return state;
  }
}

export function ImapImageUploadFailedReducer(state = false, action) {
  switch (action.type) {
    case IMAP_IMAGE_UPLOAD_FAILED:
      return action.payload;
    default:
      return state;
  }
}

export function ImapImageUploadedReducer(state = {}, action) {
  switch (action.type) {
    case IMAP_IMAGE_UPLOADED:
      return action.payload;
    default:
      return state;
  }
}

export function ImapImageUploadReducer(state = {}, action) {
  switch (action.type) {
    case IMAP_IMAGE_TO_UPLOAD:
      return action.payload;
    default:
      return state;
  }
}

/* Will use this to fetch data from "interactivemaplocation_session_link" 
    and remove this datas from "Search & Link with Booth" for session only
    */
export function interactivemaplocationsession(state = {}, action) {
  switch (action.type) {
    case INTERACTIVEMAPLOCATION_SESSION_LINK_DATA_WITH_EVENTID:
      return action.payload;
    default:
      return state;
  }
}
